import React, { useState, useEffect } from 'react';
import SelectBox from 'app/components/common/SelectBox';
import { InputText } from '@encarpkg/design';
import { getAssociations } from 'app/api';
import useIsMounted from 'app/hook/common/useIsMounted';

export const isNeedSelectFirm = (associationCode) =>
	associationCode === '19' || associationCode === '5' || associationCode === '27' || associationCode === '28';

function FirmInfoInput({
	associationValue,
	firmNameValue,
	businessNumberValue,
	onChangeAssociation,
	onChangeFirmName,
	onChangeBusinessNumber,
	onClickSearchFirm,
	associationInvalidMessage = '',
	firmNameInvalidMessage = '',
	businessInvalidMessage = '',
	onBlurFirmName = undefined,
	onBlurBusinessNumber = undefined,
	associationRef = undefined,
	firmNameRef = undefined,
	businessNumberRef = undefined,
	lockBusinessNumber = false,
}) {
	const isMounted = useIsMounted();
	const [associations, setAssociations] = useState([]);
	const associationOptions = [
		{
			key: 'default',
			name: '조합명을 선택해주세요.',
			value: '',
		},
		...associations.map((association) => ({
			key: association.code,
			name: association.name,
			value: association.code,
		})),
	];

	useEffect(() => {
		(async () => {
			try {
				const { data } = await getAssociations();
				if (isMounted()) {
					setAssociations(data);
				}
			} catch (e) {
				console.error(e);
				alert('조합 정보를 불러오지 못했습니다.');
			}
		})();
	}, [isMounted]);

	return (
		<>
			<SelectBox
				title="조합명"
				name="unionName"
				id="unionName"
				theme="uiselectbox_drop_v2"
				data={associationOptions}
				value={associationValue}
				onChange={onChangeAssociation}
				validation={!!associationInvalidMessage}
				validationText={associationInvalidMessage}
				ref={associationRef}
				labelStyle={{
					fontSize: '13px',
					fontWeight: '400',
					lineHeight: '18px',
					color: '#666',
				}}
				style={{ marginTop: '30px', borderRadius: '8px' }}
			/>
			<InputText.V2
				label="상사 상호명"
				type="text"
				id="firmName"
				name="firmName"
				value={firmNameValue}
				validation={!!firmNameInvalidMessage}
				validationText={firmNameInvalidMessage}
				onChange={onChangeFirmName}
				placeholder={associationValue ? '' : '조합명을 먼저 선택해주세요'}
				useLabel
				required
				useBtn={isNeedSelectFirm(associationValue)}
				readOnly={isNeedSelectFirm(associationValue)}
				btnText="상호명 검색"
				btnOnClick={onClickSearchFirm}
				onBlur={onBlurFirmName}
				labelStyle={{ marginTop: '20px' }}
				style={isNeedSelectFirm(associationValue) && !firmNameValue ? { backgroundColor: '#fff' } : null}
				ref={firmNameRef}
			/>
			<InputText.V2
				label="사업자번호"
				type="text"
				id="businessNumber"
				name="businessNumber"
				value={businessNumberValue}
				placeholder="‘-’ 제외하고 숫자만 입력"
				validation={!!businessInvalidMessage}
				validationText={businessInvalidMessage}
				onChange={onChangeBusinessNumber}
				onBlur={onBlurBusinessNumber}
				useLabel
				required
				readOnly={lockBusinessNumber}
				ref={businessNumberRef}
				labelStyle={{ marginTop: '20px' }}
			/>
		</>
	);
}

export default FirmInfoInput;
